import {RouteRecordRaw} from "vue-router";
import ExchangePage from '../pages/ExchangePage.vue';
import BuyCoinsPage from '../pages/BuyCoinsPage.vue';

export const routes: RouteRecordRaw[] = [
  {
    path: '/action-points/exchange',
    name: 'action-points.exchange',
    component: ExchangePage,
  },
  {
    path: '/action-points/buy-coins',
    name: 'action-points.buy-coins',
    component: BuyCoinsPage,
  }
];